import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("合并收款 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("无订单收款 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("绑定收款单")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("生成收款二维码")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("查看 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("关闭 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("代付凭证")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消绑定")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("选取文件")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("关闭")

import {ref, Ref, reactive, onBeforeMount, nextTick, watch} from 'vue'
import {ElMessage, ElMessageBox} from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import {formatNumber, formatFullTime, getNumber} from '@/utils/index'
import OrderFullCollection from '@/views/ViewsComponents/personal/orderInvoice/OrderFullCollection.vue'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'
import QrDialog from "@/views/ViewsComponents/myOrderCollection/QrDialog.vue";
import WithoutOrderRecordDialog from "@/views/ViewsComponents/myOrderCollection/WithoutOrderRecordDialog.vue";
import { updateTextLayer } from 'pdfjs-dist'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 订单收款分页查询
  'POST/order/receipt/query': fetchList,
  // 订单收款_获取收款记录
  'POST/order/receipt/payment_record': payment_recordApi,
  // 订单收款_获取收款二维码
  'POST/order/receipt/get_qr_code': get_qr_codeApi,
  // 订单收款_多订单合并收款_获取收款二维码
  'POST/order/receipt/get_qr_code_with_ids': get_qr_code_with_idsApi,
  // 订单收款_关闭二维码使其失效
  'POST/order/receipt/qr_code_close/{id}': qr_code_closeApi,
  // 订单收款_查找支付记录对应的订单列表
  'GET/order/receipt/get_merge_orders/{id}': get_merge_ordersApi,
  // 上传支付凭证
  'POST/order/payment_voucher/upload':upload_invoiceApi,
  // 订单收款_查询收款记录的凭证文件
  'GET/order/receipt/payment_record/payment_voucher/:id':paymentVocherListApi,
  // 下载
  'GET/upload/download_file':vocherDownLoadApi,
  // 删除
  'DELETE/order/payment_voucher/file/delete':vocherDeldApi,
  // 解除绑定
  'POST/order/receipt/unbind':unbindApi
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const selectionRows = ref([])
const searchEle = ref()
const orderStatusArr = [
  {label: "delivered", value: "delivered"},
  {label: "delivering", value: "delivering"},
  {label: "invoiced", value: "invoiced"},
  {label: "proceeding", value: "proceeding"},
  {label: "ready", value: "ready"},
]
const searchObj = reactive({
  orderNo: '', customerUsername: '', customerCompanyName: '', cm: '', status: '',queryAlert:false,tradeStateDescList:[]
})

const searchHandle = () => {
  fetchData({query: searchObj})
}
searchHandle()

const qrDialogInfo = reactive({
  isShow: false,
  type: 'order',
  orders: [],
  order: {},
  qrInfo: {},
})
const withoutOrderRecordDialogInfo = reactive({
  isShow: false,
  orders: []
})
// 添加
const isShowHistory = ref<boolean>(false)
const isHistoryLoad = ref<boolean>(false)
let historicalRow: any = {}
const historical = ref([])
const showHistoryHandle = (row: { id: number }) => {
  historicalRow = row
  isShowHistory.value = true
  isHistoryLoad.value = true
  payment_recordApi({orderId: row.id,"tradeStateDescList":[]}).then((rep: any) => {
    historical.value = rep
  }).finally(() => {
    isHistoryLoad.value = false
  })
}

// 修改
// console.log("codeObj",codeObj)
const getPayCodeHandle = (row: any) => {
  qrDialogInfo.type = 'order'
  qrDialogInfo.order = {
    id: row.id,
    name: row.name,
    amount: row.amount,
    receivedAmount: row.receivedAmount,
  }
  qrDialogInfo.isShow = false
  setTimeout(() => {
    qrDialogInfo.isShow = true
  }, 50)


}

// 查看历史二维码
const showHistoryCode = (row: any) => {
  qrDialogInfo.qrInfo = {
    payType: row.payType,
    paymentAmount: row.merge === true ? row.wechatAmount : row.paymentAmount,
    expirationTime: dayjs(row.createTime).add(2, 'hour').format('YYYY-MM-DD HH:mm:ss'),
    code: row.code,
    showQr: true
  }
  qrDialogInfo.type = 'showQr'
}

// 关闭未支付二维码
const closeQrCode = (row: any) => {
  ElMessageBox.confirm('请确认是否关闭', '提示', {
    type: 'warning'
  }).then(() => {
    isHistoryLoad.value = true
    return qr_code_closeApi({id: row.id})
  }).then(() => {
    ElMessage.success('关闭成功')
    showHistoryHandle(historicalRow)
  }).catch(() => {
    isHistoryLoad.value = false
  })
}

// 查看支付订单
const histoicalOrderData: any = ref([])
const isShowOrder = ref<boolean>(false)
const showHistoricalOrder = (row: any) => {
  isHistoryLoad.value = true
  get_merge_ordersApi({id: row.id}).then((rep: any[]) => {
    histoicalOrderData.value = rep
    isShowOrder.value = true
  }).finally(() => {
    isHistoryLoad.value = false
  })
}

// 批量生成收款二维码
const batchGeneration = () => {
  qrDialogInfo.type = 'merge'
  qrDialogInfo.orders = selectionRows.value
  qrDialogInfo.isShow = false
  setTimeout(() => {
    qrDialogInfo.isShow = true
  }, 50)
}
const bindOrder = () => {
  withoutOrderRecordDialogInfo.orders = selectionRows.value
  withoutOrderRecordDialogInfo.isShow = false
  setTimeout(() => {
    withoutOrderRecordDialogInfo.isShow = true
  }, 50)

}

// 黑名单订单红色高亮显示
const tableRowClassName = ({ row, rowIndex }: any) => {
  // row.payerRosterType判断历史记录中数据是否在黑名单，row.highlight判读列表中是否需要高亮数据
  if ((row.payerRosterType&&row.payerRosterType==1)||row.highlight) {
    return 'danger-corlor-row'
  }
  return ''
}

// 批量导入
const batchUploadVisiable=ref(false)
const fileList=ref<any>([])
const batchUploadRef=ref()
const batchUploadLoading=ref(false)
const currentOrderData=ref<any>({})
const batchUploadHandle=(row:any)=>{
    batchUploadVisiable.value=true
    currentOrderData.value=row
    getPaymentVocherList()
}
const bantchUploadMethod=({file}:any)=>{
    const formData = new FormData()
    formData.append(`file`,file)
    formData.append('id',currentOrderData.value.id)
    batchUploadLoading.value=true
    upload_invoiceApi(formData).then((res:any)=>{
        ElMessage.success("上传成功")      
        getPaymentVocherList()        
    }).finally(()=>{
        batchUploadLoading.value=false
    })
}
const resetBatchUpload=()=>{
    fileList.value=[]
    currentOrderData.value={}
    paymentVocherList.value=[]
    batchUploadRef.value.clearFiles()
}
const paymentVocherList=ref([])
const paymentVocherListLoading=ref(false)
const getPaymentVocherList=()=>{
  paymentVocherListLoading.value=true
  paymentVocherListApi({id:currentOrderData.value.id}).then((res:any)=>{
    paymentVocherList.value=res
  }).finally(()=>{
    paymentVocherListLoading.value=false
  })
}
const downloadHandle=(fileId:any)=>{
    vocherDownLoadApi({fileId},{timeout: 5 * 60000, responseType: 'blob'}).then((res:any)=>{
        let url= window.URL.createObjectURL(
            new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
        )
        // 下载
        let fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        let link = document.createElement("a")
        link.style.display = "none"
        link.href = url
        link.setAttribute(
        "download",
        decodeURI(fileName)
        )
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)        
    })
}
const delHandle=(fileId:any)=>{
  ElMessageBox.confirm('确定删除？',{confirmButtonText:"确定",cancelButtonText:"取消"}).then(()=>{
      vocherDeldApi({fileId,id:currentOrderData.value.id}).then(()=>{
        ElMessage.success("删除成功")
        getPaymentVocherList()
      })
  })
}

const unBindHandle=(data:any)=>{
  let message=data.merge?'确认取消订单与流水的绑定吗？由于涉及到合并收款，此操作将同时自动解绑与该流水关联的所有其他订单的绑定':'确认取消订单与流水的绑定吗？'
  ElMessageBox.confirm(message,{confirmButtonText:"确定",cancelButtonText:"取消"}).then(()=>{
    unbindApi({recordId:data.id}).then(()=>{
      ElMessage.success('解绑成功')
      showHistoryHandle(historicalRow)
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "收款" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, { class: "mb-10" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "点此搜索" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      ref_key: "searchEle",
                      ref: searchEle,
                      model: _unref(searchObj),
                      "label-width": "auto",
                      inline: "",
                      class: "searchBg",
                      disabled: _unref(MI_identify)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "订单号:",
                          prop: "orderNo"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(searchObj).orderNo,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
                              placeholder: "请输入订单号",
                              clearable: "",
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "客户ID:",
                          prop: "customerUsername"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(searchObj).customerUsername,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).customerUsername) = $event)),
                              placeholder: "请输入客户ID",
                              clearable: "",
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "客户名:",
                          prop: "customerCompanyName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(searchObj).customerCompanyName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).customerCompanyName) = $event)),
                              placeholder: "请输入客户名",
                              clearable: "",
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "客户经理:",
                          prop: "cm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(searchObj).cm,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).cm) = $event)),
                              placeholder: "请输入客户经理",
                              clearable: "",
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "订单状态:",
                          prop: "status"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(searchObj).status,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).status) = $event)),
                              placeholder: "订单状态"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderStatusArr, (item) => {
                                  return _createVNode(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"])
                                }), 64))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "历史收款记录:",
                          prop: "tradeStateDescList"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              multiple: "",
                              clearable: "",
                              modelValue: _unref(searchObj).tradeStateDescList,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).tradeStateDescList) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "SUCCESS",
                                  label: "支付成功"
                                }),
                                _createVNode(_component_el_option, {
                                  value: "NOTPAY",
                                  label: "未支付"
                                }),
                                _createVNode(_component_el_option, {
                                  value: "EXPIRED",
                                  label: "已过期"
                                }),
                                _createVNode(_component_el_option, {
                                  value: "CLOSED",
                                  label: "已关闭"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "",
                          prop: "queryAlert"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              modelValue: _unref(searchObj).queryAlert,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).queryAlert) = $event)),
                              label: "仅展示涉及代付凭证的订单"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (searchEle.value.resetFields()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (searchHandle()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                disabled: selectionRows.value.length <= 1,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (batchGeneration()))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                class: "ml-20",
                plain: "",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push({ name: 'myOrderCollectionExtra' })))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                class: "ml-20",
                plain: "",
                disabled: selectionRows.value.length < 1,
                onClick: bindOrder
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "row-class-name": tableRowClassName,
              onSelectionChange: _cache[11] || (_cache[11] = (rows) => selectionRows.value = rows),
              ref: "tb",
              border: "",
              data: _unref(MI_tableData),
              class: "mt-10",
              "max-height": _unref(MI_height) - 60 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  fixed: "",
                  selectable: (row) => row.currency.toLowerCase() === 'cny'
                }, null, 8, ["selectable"]),
                _createVNode(_component_el_table_column, {
                  label: "订单号",
                  width: "140",
                  prop: "no",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "订单名称",
                  prop: "name",
                  width: "190",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票主体",
                  prop: "invoiceCompany",
                  width: "190",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户ID",
                  width: "140",
                  prop: "customerUsername",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户名称",
                  width: "140",
                  prop: "customerCompanyName",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户联系人",
                  width: "140",
                  prop: "customerContactor",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户经理",
                  width: "140",
                  prop: "owner"
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  width: "90",
                  prop: "currency"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  width: "120",
                  prop: "amount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "总计已收款金额",
                  width: "140",
                  prop: "receivedAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "历史收款记录",
                  width: "130"
                }, {
                  default: _withCtx(({row}) => [
                    (row.hasPayRecord === true)
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "primary",
                          onClick: ($event: any) => (showHistoryHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "开始日期",
                  prop: "startTime",
                  formatter: _unref(formatFullTime),
                  width: "140",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "交付日期",
                  prop: "deliverTime",
                  formatter: _unref(formatFullTime),
                  width: "140",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "订单状态",
                  width: "120",
                  prop: "status"
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "130"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (getPayCodeHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              background: "",
              small: "",
              class: "mt-10",
              disabled: _unref(MI_identify),
              total: _unref(MI_total),
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              "page-size": _unref(size),
              "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
              "page-sizes": [30, 50, 100, 500],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "已全额收款",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(OrderFullCollection)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: isShowHistory.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isShowHistory).value = $event)),
      title: "历史收款记录",
      width: "1200px"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-class-name": tableRowClassName,
          data: historical.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              type: "index",
              width: "80"
            }),
            _createVNode(_component_el_table_column, {
              prop: "paymentAmount",
              label: "金额",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "创建时间",
              width: "180",
              formatter: _unref(formatFullTime)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "createName",
              label: "创建人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "tradeStateDesc",
              label: "支付状态"
            }),
            _createVNode(_component_el_table_column, {
              prop: "payerId",
              label: "付款ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "payType",
              label: "收款方式",
              formatter: (row) => row.payType === 'WECHAT' ? '微信' :'支付宝'
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "merge",
              label: "是否合并收款",
              formatter: (row) => row.merge === true ? '是' :'否'
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "200"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    (row.merge !== true || row.wechatAmount !== 0)
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "primary",
                          onClick: ($event: any) => (showHistoryCode(row)),
                          disabled: row.tradeState?.toLowerCase() === 'success' && row.amount == 0
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"]))
                      : _createCommentVNode("", true),
                    (row.tradeState?.toLowerCase() === 'notpay')
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 1,
                          type: "danger",
                          onClick: ($event: any) => (closeQrCode(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (row.tradeState=='SUCCESS')
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 2,
                          underline: false,
                          onClick: ($event: any) => (batchUploadHandle(row)),
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (row.tradeState=='SUCCESS')
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 3,
                          underline: false,
                          onClick: ($event: any) => (unBindHandle(row)),
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, isHistoryLoad.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowOrder.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isShowOrder).value = $event)),
      title: "收款订单"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: histoicalOrderData.value,
          "show-summary": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "no",
              label: "订单号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "金额",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: batchUploadVisiable.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((batchUploadVisiable).value = $event)),
      onClose: _cache[18] || (_cache[18] = ($event: any) => (resetBatchUpload())),
      title: "上传代付凭证"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: batchUploadLoading.value,
          onClick: _cache[16] || (_cache[16] = ($event: any) => (batchUploadVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          "auto-upload": true,
          ref_key: "batchUploadRef",
          ref: batchUploadRef,
          "show-file-list": false,
          disabled: batchUploadLoading.value,
          "http-request": bantchUploadMethod
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_12,
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Upload)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          class: "mt-10",
          data: paymentVocherList.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "filename",
              label: "文件名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "username",
              label: "上传人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "uploadAt",
              label: "上传时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "ops",
              label: "操作"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      underline: false,
                      type: "primary",
                      onClick: ($event: any) => (downloadHandle(row.fileId))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      underline: false,
                      type: "danger",
                      onClick: ($event: any) => (delHandle(row.fileId))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, paymentVocherListLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(QrDialog, {
      "is-show": _unref(qrDialogInfo).isShow,
      type: _unref(qrDialogInfo).type,
      order: _unref(qrDialogInfo).order,
      "qr-info": _unref(qrDialogInfo).qrInfo,
      orders: _unref(qrDialogInfo).orders,
      onRefresh: searchHandle
    }, null, 8, ["is-show", "type", "order", "qr-info", "orders"]),
    _createVNode(WithoutOrderRecordDialog, {
      orders: _unref(withoutOrderRecordDialogInfo).orders,
      "is-show": _unref(withoutOrderRecordDialogInfo).isShow,
      onRefresh: searchHandle
    }, null, 8, ["orders", "is-show"])
  ]))
}
}

})